import React from 'react';

export const BlockDirectoryEntry = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'block-directory-entry' */
            './BlockDirectoryEntry'
        ),
);
